module.exports = __webpack_public_path__ + "static/stars-bg-9a99a36a788b3965d00467d8a64a256c.png";